import misc from '../misc/misc';
import RemoteObject from './RemoteObject';
import PagedObjects from './PagedObjects';

export default class ResponseBody {
  constructor(responseBody) {
    this.responseBody = misc.objectKeysToCamelCase(responseBody);
    this.parsedRemoteObject = null;
    this.parsedRemoteObjects = null;
    this.parsedPagedObjects = null;
  }

  isSuccess() {
    return this.responseBody.errorCode === 0; // respErrorCode.ERROR_CODES.SUCCESS;
  }

  isFailure() {
    return this.responseBody.errorCode !== 0; // respErrorCode.ERROR_CODES.SUCCESS;
  }

  getErrorCode() {
    return this.responseBody.errorCode;
  }

  getErrorMsg() {
    return this.responseBody.errorMsg;
  }

  getRetObject() {
    return this.responseBody.retObject;
  }

  getRetLong() {
    return this.responseBody.retLong;
  }

  getRetBoolean() {
    return this.responseBody.retBoolean;
  }

  getRetDouble() {
    return this.responseBody.retDouble;
  }

  getRetString() {
    return this.responseBody.retString;
  }

  getRemoteObject() {
    if (!this.parsedRemoteObject) {
      if (this.responseBody.retObject) {
        this.parsedRemoteObject = new RemoteObject(this.responseBody.retObject);
      }
    }
    return this.parsedRemoteObject;
  }

  getPagedObjects() {
    if (!this.parsedPagedObjects) {
      if (this.responseBody.retObject) {
        this.parsedPagedObjects = new PagedObjects(this.responseBody.retObject);
      }
    }
    return this.parsedPagedObjects;
  }

  getRemoteObjects() {
    if (!this.parsedRemoteObjects) {
      if (this.isPagedObjects()) {
        this.parsedRemoteObjects = this.getPagedObjects().getRemoteObjects();
      } else if (Array.isArray(this.responseBody.retArray)) {
        this.parsedRemoteObjects =
          this.responseBody.retArray.map(el => (el ? new RemoteObject(el) : null));
      }
    }
    return this.parsedRemoteObjects;
  }

  isPagedObjects() {
    return this.responseBody.retObject &&
      this.responseBody.retObject.totalCount !== undefined &&
      this.responseBody.retObject.listRefId !== undefined;
  }

  getRetBlob() {
    return this.responseBody.retBlob;
  }

  getRetArray() {
    return this.responseBody.retArray;
  }

  getExtraLong1() {
    return this.responseBody.extraLong1;
  }

  getExtraLong2() {
    return this.responseBody.extraLong2;
  }
}
